import { render, staticRenderFns } from "./smrz.vue?vue&type=template&id=fbcbd5fa&scoped=true"
import script from "./smrz.vue?vue&type=script&lang=js"
export * from "./smrz.vue?vue&type=script&lang=js"
import style0 from "./smrz.vue?vue&type=style&index=0&id=fbcbd5fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcbd5fa",
  null
  
)

export default component.exports